import { Popup } from "semantic-ui-react";
import React, { useMemo } from "react";
import { ContentPage } from "@/services/bedrock";

interface OwnProps {
  contentPageViewSummary?: ContentPage.ViewSummary;
  trigger: React.ReactNode;
}

type Props = OwnProps;

const VideoPageStatsPopupFC: React.FC<Props> = ({ contentPageViewSummary, trigger }) => {
  const statCutoff = 10;

  const showCities = useMemo(() => {
    return contentPageViewSummary && contentPageViewSummary.cities.length < statCutoff;
  }, [contentPageViewSummary]);

  const showStates = useMemo(() => {
    return (
      contentPageViewSummary &&
      contentPageViewSummary.cities.length >= statCutoff &&
      contentPageViewSummary.states.length < statCutoff
    );
  }, [contentPageViewSummary]);

  const statSection = (label: string, stats?: ContentPage.StatGrouping[]) => {
    return (
      stats &&
      stats.length > 0 && (
        <>
          <div>
            <b>{label}:</b>
          </div>
          <ul className="pl-10">
            {stats?.map(stat => (
              <li key={`stat-${stat.label}`}>
                {stat.label} - {stat.percentage}%
              </li>
            ))}
          </ul>
        </>
      )
    );
  };

  return (
    <Popup trigger={trigger}>
      <Popup.Header>View Stats</Popup.Header>
      <Popup.Content>
        {showCities && statSection("Cities", contentPageViewSummary?.cities)}
        {showStates && statSection("States", contentPageViewSummary?.states)}
        {statSection("Devices", contentPageViewSummary?.deviceClasses)}
        {statSection("Watch Percentage", contentPageViewSummary?.watchPercentages)}
      </Popup.Content>
    </Popup>
  );
};

export const VideoPageStatsPopup = VideoPageStatsPopupFC;
